import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';

export default class CompleteLookComponent extends Component {
  get SELECTORS() {
    return {
      scroller: '[data-wrapper]',
    };
  }

  get COMPONENTNAME() {
    return 'CompleteLookComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.scroller = this.$component.querySelector(this.SELECTORS.scroller);
  }
  render() {
    super.render();
    if (isMobile(MobileBreakpoint.Max767)) {
      this.moduleLoader.loadSimpleBarAndExecute(
        module => {
          this.initSimpleBar(module.default);
        },
        error => {
          console.log('failed to load SimpleBar ', error.stack);
        }
      );
    }
  }
  initSimpleBar(SimpleBar) {
    this.simpleBar = new SimpleBar(this.scroller, {
      autoHide: false,
    });
  }
}
